<template>
  <div class="favorite-search">
    <p class="font-label-xl-sb m-0">
      Pencarian Terpopuler
    </p>
    <div class="tag-container">
      <router-link
        v-for="(item, index) in popularKeywords"
        :id="`tag-${index}`"
        :key="`tag-${index}`"
        :to="{
          name: 'Program',
          query: {
            search: item.name,
            ...(ref) && { ref }
          }
        }"
        class="tag font-label-4"
      >
        <img
          src="https://cdn.karier.mu/assets/v3/icon/icon-search-blue.svg"
          alt="icon-search"
          class="search-icon"
        >
        {{ item.name }}
      </router-link>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'

export default {
  name: 'NavbarFavoriteSearch',
  computed: {
    ...mapState('discovery', ['popularKeywords']),
    ref () {
      return !this.$store.state.isPrakerja ? '' : 'prakerja-pencarian'
    }
  }
}
</script>

<style scoped>
.favorite-search {
  display: flex;
  flex-direction: column;
  gap: 24px;
}

.tag-container {
  display: flex;
  flex-wrap: wrap;
  align-items: flex-start;
  gap: 8px;
  align-self: stretch;
}

.tag {
  display: flex;
  padding: 4px 12px;
  justify-content: center;
  align-items: center;
  text-decoration: none;
  gap: 4px;
  border-radius: 20px;
  background: var(--color-royal-navy-100);
  color: var(--color-royal-navy-500);
  text-align: center;
  border: none;
}

.search-icon {
  filter: invert(25%) sepia(97%) saturate(1571%) hue-rotate(192deg) brightness(98%) contrast(108%);
}
</style>
